import { createExtendedStore } from '../utils/utils.store';

const initialState = {
  allocated: [],
  dealerOffers: [],
  buyingCenters: [],
  closestDealerships: [],
  dealerId: 0, // todo move to offer?
  dealerRepId: 0, // todo move to offer?
  dealerRepName: '', // todo move to offer?
  dealerGuid: '',
  inviteId: '',
  authToken: '',
  tradeInCenters: [],
  name: '',
  numAssignableDealers: 0,
  isDealerCobrandingDrEnabled: false,
  dealershipName: '',
  dealerAppointmentInfo: null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cobrandingGroupId: '' as any,
  enabled: true,
  acceptsReplacementVehicleAnswers: true,
  measurementId: '',
};

const { on, onChange, state, reset, partialReset } = createExtendedStore(initialState);

export { on, onChange, state, reset, partialReset };
export default state;
